import { z } from "zod";

export const CatalogSlug = z
  .string()
  .min(3)
  .max(64)
  .regex(/^[a-z0-9][a-z0-9-]{1,62}[a-z0-9]$/)
  .meta({
    id: "CatalogSlug",
    description: "A user-chosen URL-safe catalog name.",
    example: "eve-of-barbarossa",
  });
export type CatalogSlug = z.infer<typeof CatalogSlug>;

export const CatalogFileName = z
  .string()
  .min(1)
  .max(128)
  .regex(/^[a-zA-Z0-9][a-zA-Z0-9._-]*$/)
  .meta({
    id: "CatalogFileName",
    description: "One flat file name in an immutable version artifact.",
    example: "world.json",
  });
export type CatalogFileName = z.infer<typeof CatalogFileName>;
export const Sha256 = z
  .string()
  .regex(/^[a-f0-9]{64}$/)
  .meta({
    id: "Sha256",
    description: "Lowercase hexadecimal SHA-256 of the exact file bytes.",
    example: "9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a08",
  });
export type Sha256 = z.infer<typeof Sha256>;

/**
 * Where the private bucket keeps a blob: once, under its SHA-256, in a folder of its first two hex
 * digits, after the environment's namespace.
 */
export function blobKey(namespace: string, sha256: string): string {
  return `${namespace}${sha256.slice(0, 2)}/${sha256}`;
}

export const catalogPublisherRefusal = {
  UNAUTHORIZED: { message: "Sign in with a service API key to publish to the catalog." },
  FORBIDDEN: { message: "Only a service user may publish to the catalog." },
} as const;
